var _defs, _rect, _path, _rect2, _path2, _rect3, _path3, _rect4, _path4, _rect5, _path5, _rect6, _path6, _rect7, _path7, _text, _text2, _text3, _text4, _text5, _text6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDraught(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "361px",
    height: "202px",
    viewBox: "-0.5 -0.5 361 202",
    content: "<mxfile modified=\"2019-03-16T13:41:55.432Z\" host=\"www.draw.io\" agent=\"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_2) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/73.0.3683.75 Safari/537.36\" etag=\"ENswGP_YfVBejWIwuCRb\" version=\"10.4.8\" type=\"device\"><diagram id=\"pQUE4dnGw_Fm3Zc5Ilks\" name=\"Page-1\">7Zhdb5swFIZ/DZeV+DJJLvPRdmq1TVsqVdqdCw5YdTA1JpD9+h3ATiBQqZOaINTcRPZr+9h+3kNsMJzltrgXOIm+84AwwzaDwnBWhm1P0BR+S2FfCy5yaiEUNKgl6yis6V+iRFOpGQ1I2uooOWeSJm3R53FMfNnSsBA8b3fbcNaeNcEh6QhrH7Ou+kwDGSnV8mbHhm+EhpGaempP6oYt1p3VTtIIBzxvSM6t4SwF57IubYslYSU7zaUed/dO62FhgsTyIwPe7u3fu1/FIkHpq+X5j38e8t2NirLDLFMbVouVe00A1p2UxURwn6SAc5FHVJJ1gv1SzsF20CK5ZVCzoPiC/ddQ8CwOfmaS0ZgoXU1FhCTFu3uwDmQgowjfEin20EUNsKcKpsoma6LqecMbDTxq2KLTCat0CA+hj8SgoKD9B0B73AAPYAYD6IwLoGt+IAP7+M3OBdAdGUDrJAPtoTMQjRygZw8M0Bs3QMf0BgY4GTlANPQjPO0B6DFZYoBCKKt918KGwyabaL23jOuGm7S6gM6hgzVNimOjjvJ0p+PAOutQ7fAgN6Y8MRGQy7ZLgsCM+KXqYEI94TSWFR20MNAKFJxJXq+qGoAZDWMoM7IpQ5U+UritzpUseZkGKWQFjcOnsrKCA+Jzrg7uycnnoY7rbo/p9rlMn13K9C/sOTo5a8yu584lPdf/IBd40r+s6cg9fUfoXjAua3rfW+pZTF9fTdemI3dg0/verM9i+vPV9MNNuHuRu6zpfV8DzmP6j/nVdm27233Wvc+xHarHL5xVW+MzsXP7Dw==</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 5,
    width: 120,
    height: 10,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 52 5 L 52 15 M 148 5 L 148 15",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 45,
    width: 120,
    height: 10,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 52 45 L 52 55 M 148 45 L 148 55",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 5,
    width: 10,
    height: 190,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 161 5 L 161 195 M 169 5 L 169 195",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 55,
    width: 120,
    height: 10,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 182 55 L 182 65 M 278 55 L 278 65",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 97,
    width: 120,
    height: 10,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 182 97 L 182 107 M 278 97 L 278 107",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 141,
    width: 120,
    height: 10,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 182 141 L 182 151 M 278 141 L 278 151",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 185,
    width: 120,
    height: 10,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "none"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 182 185 L 182 195 M 278 185 L 278 195",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.5,2.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 22,
    height: 19,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 18
    }
  }, "TF"))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 11,
    y: 16,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "[Not supported by viewer]")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.5,42.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 11,
    height: 19,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 18
    }
  }, "F"))))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 6,
    y: 16,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "[Not supported by viewer]")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(301.5,49.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 11,
    height: 19,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 18
    }
  }, "T"))))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 6,
    y: 16,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "[Not supported by viewer]")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(301.5,91.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 12,
    height: 19,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 18
    }
  }, "S"))))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 6,
    y: 16,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "[Not supported by viewer]")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(301.5,137.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 17,
    height: 19,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 18
    }
  }, "W"))))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 9,
    y: 16,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "[Not supported by viewer]")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(301.5,181.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 43,
    height: 19,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 18
    }
  }, "WNA"))))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 22,
    y: 16,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "[Not supported by viewer]"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraught);
export default __webpack_public_path__ + "static/media/draught.9008ff74b8a254540f120a559bc3c635.svg";
export { ForwardRef as ReactComponent };